/**
 * The one place every generated API call goes through.
 *
 * orval is pointed at this by `override.mutator`, so the attachment happens for every
 * endpoint by construction rather than by each call site remembering. A new endpoint is
 * authenticated the moment it is generated.
 *
 * The token goes in a header rather than a cookie even though the browser sees one origin
 * (Hosting rewrites /api to Cloud Run, charter 6.6) and a cookie would therefore work. A
 * cookie is attached to every request the page makes whether or not anything asked for it,
 * which is the shape of CSRF; a header is attached by code that meant to.
 */
import { idToken } from '../auth/firebase'

export async function http<T>(url: string, options: RequestInit): Promise<T> {
  const token = idToken()
  const headers = new Headers(options.headers)
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  const res = await fetch(url, { ...options, headers })

  const body = [204, 205, 304].includes(res.status) ? null : await res.text()
  const data = body ? JSON.parse(body) : {}

  return { data, status: res.status, headers: res.headers } as T
}

export default http
